/* ============
 * Home Index
 * ============
 *
 * This is the release notes page.
 */
import releaseNoteService from './../../../services/releaseNote';
import DateMixin from './../../../mixins/date';

export default {
  data() {
    return {
      loading: true,
      releaseNotes: [],
    };
  },

  mounted() {
    releaseNoteService.all().then((data) => {
      this.releaseNotes = data;
    });
  },

  mixins: [
    DateMixin,
  ],

};



// WEBPACK FOOTER //
// ./src/app/pages/home/releaseNotes/releaseNotes.js